export const messages = {
  defaultLoadingMessage: 'Loading...',
  defaultExportLoadingMessage: 'This may take several minutes...',
} as const
